// Base implementations of the helper functions are exported individually.
/**
 * Tests whether a given value has a non-zero value.
 * With zero being:
 *     - undefined
 *     - null
 *     - ''
 *     - 0
 *     - []
 *     - {}
 * @param val
 * @returns {boolean}
 */
export const empty = val => (undefined === val || 0 === val || null === val || '' === val || [] === val || {} === val);

// The default export is an object that has every function as value
// Example:
//    import utils from 'util-functions';
//    import someVariable from 'somewhere';
//    console.log(`someVariable is empty is a ${utils.empty(someVariable)} statement!`);
export default {
  empty,
};
